/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {string} The key used to store viewed product handles */
  static #HANDLES_STORAGE_KEY = 'recentlyViewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;
  /** @static @constant {number} The maximum number of product handles to store */
  static #MAX_HANDLES = 12;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {string} [productHandle] - The handle of the product to add.
   */
  static addProduct(productId, productHandle) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));

    if (productHandle) {
      let viewedHandles = this.getHandles();

      viewedHandles = viewedHandles.filter((/** @type {string} */ handle) => handle !== productHandle);
      viewedHandles.unshift(productHandle);
      viewedHandles = viewedHandles.slice(0, this.#MAX_HANDLES);

      localStorage.setItem(this.#HANDLES_STORAGE_KEY, JSON.stringify(viewedHandles));
    }
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
    localStorage.removeItem(this.#HANDLES_STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  /**
   * Retrieves the list of recently viewed product handles from localStorage.
   * @returns {string[]} The list of viewed product handles.
   */
  static getHandles() {
    try {
      const handles = JSON.parse(localStorage.getItem(this.#HANDLES_STORAGE_KEY) || '[]');
      return Array.isArray(handles) ? handles : [];
    } catch (error) {
      return [];
    }
  }
}
